import {
  MAPPER_KEY,
  TFN_OUTCOME_KEYS,
  DECLARE_TRUE_AND_CORRECT_STATUSES,
  YES_NO_LABEL_MAP,
  TITLE_MAP,
  TFN_EXEMPTION_LABEL_MAP,
  PAY_BASIS_LABEL_MAP,
  RESIDENCY_LABEL_MAP,
  RESIDENCY_MAP,
  TFN_EXEMPTION_MAP,
  TAX_FREE_THRESHOLD_MAP,
  HAS_LOAN_OR_STUDENT_DEBT_MAP,
  PAY_BASIS_MAP,
} from './superstep-constants';

/**
 * Maps TFN declaration data from SuperAPI to indexed field structure
 * @param {Object} tfn_declaration - The TFN declaration data from SuperAPI
 * @param {Object} result - The result object to populate with mapped values
 */
export function mapTfnDeclarationData(tfn_declaration, result) {
  if (!tfn_declaration) {
    return;
  }

  const { outcome: tfnOutcome, tfn_declaration: tfnDetails } = tfn_declaration;

  if (
    tfnDetails &&
    (tfnOutcome === TFN_OUTCOME_KEYS.COMPLETE ||
      tfnOutcome === TFN_OUTCOME_KEYS.COMPLETE_UNSUCCESSFUL)
  ) {
    // Map TFN option and number
    if (tfnDetails.tfn) {
      result[MAPPER_KEY.TFN_OPTION].value = YES_NO_LABEL_MAP.Yes;
      result[MAPPER_KEY.TFN_NUMBER].value = tfnDetails.tfn;
    } else {
      result[MAPPER_KEY.TFN_OPTION].value = YES_NO_LABEL_MAP.No;
      if (tfnDetails.tfn_exemption_type) {
        const exemptionCode =
          TFN_EXEMPTION_MAP[tfnDetails.tfn_exemption_type] ||
          tfnDetails.tfn_exemption_type;
        result[MAPPER_KEY.TFN_REASON].value =
          TFN_EXEMPTION_LABEL_MAP[exemptionCode] || exemptionCode;
      }
    }

    // Map title
    if (tfnDetails.title) {
      result[MAPPER_KEY.TFN_PERSONAL_TITLE].value =
        TITLE_MAP[tfnDetails.title.toLowerCase()] ||
        capitalizeFirstLetter(tfnDetails.title);
    }

    // Map full name
    if (tfnDetails.given_name && tfnDetails.family_name) {
      const fullName = tfnDetails.middle_name
        ? `${tfnDetails.given_name} ${tfnDetails.middle_name} ${tfnDetails.family_name}`
        : `${tfnDetails.given_name} ${tfnDetails.family_name}`;
      result[MAPPER_KEY.TFN_PERSONAL_FULL_NAME].value = fullName;
    }

    // Map pay basis
    if (tfnDetails.pay_basis) {
      const payBasisCode =
        PAY_BASIS_MAP[tfnDetails.pay_basis] || tfnDetails.pay_basis;
      result[MAPPER_KEY.TFN_TAX_PAY_BASIS].value =
        PAY_BASIS_LABEL_MAP[payBasisCode] || payBasisCode;
    }

    // Map residency status
    if (tfnDetails.residency_type) {
      const residencyCode =
        RESIDENCY_MAP[tfnDetails.residency_type] || tfnDetails.residency_type;
      result[MAPPER_KEY.TFN_TAX_RESIDENT_STATUS].value =
        RESIDENCY_LABEL_MAP[residencyCode] || residencyCode;
    }

    // Map country of origin
    if (tfnDetails.country_of_origin_name) {
      result[MAPPER_KEY.TFN_TAX_COUNTRY_OF_ORIGIN].value =
        tfnDetails.country_of_origin_name;
    }

    // Map tax-free threshold
    if (tfnDetails.tax_free_threshold_claimed !== undefined) {
      const thresholdCode =
        TAX_FREE_THRESHOLD_MAP[tfnDetails.tax_free_threshold_claimed];
      result[MAPPER_KEY.TFN_TAX_FREE_THRESHOLD].value =
        YES_NO_LABEL_MAP[thresholdCode] || thresholdCode;
    }

    // Map loan/student debt
    if (
      tfnDetails.has_study_and_training_repayment !== undefined ||
      tfnDetails.has_financial_supplement_debt !== undefined
    ) {
      const hasDebt =
        tfnDetails.has_study_and_training_repayment ||
        tfnDetails.has_financial_supplement_debt;
      const debtCode = HAS_LOAN_OR_STUDENT_DEBT_MAP[hasDebt];
      result[MAPPER_KEY.TFN_TAX_HAS_LOAN_OR_STUDENT_DEBT].value =
        YES_NO_LABEL_MAP[debtCode] || debtCode;
    }

    // Map declaration
    if (tfnDetails.declaration_tfnd_accepted) {
      result[MAPPER_KEY.TFN_TAX_DECLARE_TRUE_AND_CORRECT].value =
        DECLARE_TRUE_AND_CORRECT_STATUSES.CHECKED;
    } else {
      result[MAPPER_KEY.TFN_TAX_DECLARE_TRUE_AND_CORRECT].value =
        DECLARE_TRUE_AND_CORRECT_STATUSES.NOT_CHECKED;
    }
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
